import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "unit_name",
    name: "Unit Name",
  },
  {
    key: "status",
    name: "Status",
  },
];

export default function UnitList() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchValue, setSearchValue] = useState("");
   

  const handleSearch = (value) => {
    setSearchValue(value.trim())
    setQuery({
      unit_name: value.trim(),
    });
  };

  //   const handleSearch = (value) => {
  //   const trimmed = value.trim();
  //   if(trimmed.length > 0){
  //     setSearchValue(trimmed);
  //     setQuery({
  //       unit_name: trimmed,
  //     });
  //   }else{
  //       setQuery({
      
  //   });
  //   }
  // };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/unit",
    defaultQuery: "status=ACTIVE",
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Unit List"
      data={data}
      headers={headers}
      idKey="unit_id"
      endPoint="/unit"
      removeDetails={true}
      module="Unit"
      subModule="Unit List"
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      hasActions
      createPath={`/unit/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
}
